export default __webpack_public_path__ + "static/Renato-b5d758afb7a075c60c9fab0ddfd81d86865bf7a890dd661053aae34a28589dc0.svg";